import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AuthService } from '../../service/auth-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-verify-email',
  imports: [],
  templateUrl: './verify-email.html',
  styleUrl: './verify-email.scss'
})
export class VerifyEmail implements OnInit{
  protected loading = false;
  private authService = inject(AuthService)
  private snackBar = inject(MatSnackBar)
  private returnUrl: string = '/';
  private route = inject(ActivatedRoute)
  private router = inject(Router)
  private analytics = inject(Analytics);
  private platformId = inject(PLATFORM_ID);

  ngOnInit() {
    if(isPlatformBrowser(this.platformId)){
      logEvent(this.analytics, 'verify_email_page_view', { page_path: '/verify-email' });
    }
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/';
  }

  resendVerification() {
    this.loading = true;
    this.authService.resendVerificationEmail()
      .then(() => {
        this.loading = false;
        this.snackBar.open('Verification email sent! Check your inbox.', 'Close', { duration: 5000 });
      })
      .catch((err) => {
        this.snackBar.open("Error sending verification email", 'Close', { duration: 5000 });
        console.error(err);
      }).finally(() => {
        this.loading = false;
      });
  }

  navigateToReturnUrl() {
    // this.router.navigateByUrl(this.returnUrl);
    //  window.location.href = this.returnUrl;
    this.authService.checkEmailVerified().then((res) => {
      // this.router.navigateByUrl(this.returnUrl);
      window.location.href = this.returnUrl;
    }).catch((err) => {
      console.error('Error checking email verification', err);
      this.snackBar.open("Error verifying email. Please try again.", 'Close', { duration: 5000 });
    });

  }
}
